import { Component, OnInit } from '@angular/core';
import { CommonService, AdministrationService } from '../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { Role } from '../../../models';
import { Location } from '@angular/common';
import { Utils } from '../../../utils';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-users-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.css']
})
export class UsersRolesComponent implements OnInit {
    roles: Role[];
    idUser: number;
    selectedRoles: number[];

    constructor(
        private commonsService: CommonService,
        private administrationService: AdministrationService,
        private location: Location,
        private router: Router,
        private utils: Utils,
        private messageService: MessageService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.commonsService.getAllRoles().subscribe(
            roles => this.roles = roles,
            error => {
                console.error(error);
            }
        );

        this.route.params.subscribe(params => {
            this.idUser = params['id'];
            this.administrationService.getUserRoles(this.idUser).subscribe(
                roles => this.selectedRoles = roles.map(r => r.id)
            );
        });
    }

    setRoles() {
        console.log(this.selectedRoles);
        this.administrationService.setUserRoles(this.idUser, this.selectedRoles).subscribe(
            () => {
                this.messageService.add({ severity: 'success', summary: 'Role zostały nadane' });
                this.router.navigate(['/users'])
            },
            error => {
                this.messageService.add({ severity: 'error', summary: 'Błąd podczas nadawania ról', detail: this.utils.handleError(error) });
            }
        );
    }

    cancel() {
        this.location.back();
    }
}
